import React, { Component } from 'react';
import { Modal, Button, Row, Col, FormGroup, FormControl, FormLabel, InputGroup, Table } from 'react-bootstrap';
import _ from 'lodash';
import { JSEncrypt } from 'jsencrypt';
import Picky from 'react-picky';
import ProcessWise from './ProcessWise';
import 'react-picky/dist/picky.css'; // Include CSS
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
export default class EditUserDetails extends Component {  
   constructor(props, context) {
        super(props, context);    
        this.state = {
          employeeId:props.edit ? props.edit.employeeId : '',
          firstName: props.edit ? props.edit.firstName : '',
          lastName: props.edit ? props.edit.lastName : '',
          password: '',
          supervisorUsersName: props.edit ? props.edit.supervisorUsersName : '',
          email: props.edit ? props.edit.email : '',
          mobileNumber: props.edit ? props.edit.mobileNumber : '', 
          status: props.edit ? props.edit.status : 'NEW',
          selectedregionName: [],
          selectedcenterName:  [],
          selectedclientName: [],
          selectedprocessName: [],
          selectedrole: [],
          selectedReports: [],
          selectedSupervisor:[],
          userstatus:props.edit.status === 'ACTIVE' ? true : false,
          userrecordStatus : props.edit.status,
          leaveInfo:props.edit.userLeaveDetails,
          emailIsValid:true
        }
      this.bulkclientName=[]
    };
    componentWillMount(){
      const{edit, inventory, rolesData, reportlist, supervisorData} = this.props;   
      const {leaveInfo}  = this.state;
      let clientsObj = []; let processObj=[]; let reportli =[];  let centerObj =[]; let regionObj =[]
      if(edit){
        if(!_.isEmpty(edit.userInventoryMaps)){
          _.map(edit.userInventoryMaps, (obj) =>{               
            let x = _.find(inventory, {"inventoryRegionId" : obj.inventoryRegionId})
            if(!_.isEmpty(x)){     
             regionObj.push(x)
            }
            _.map(obj.userCenters, (y)=>{
              let new_centers= _.find(x.centers, {"inventoryCenterId" : y.inventoryCenterId})
              if(!_.isEmpty(new_centers)){     
                centerObj.push(new_centers)
               }
               _.map(y.userClients, (z) =>{
                  let new_clients= _.find(new_centers.clients, {"inventoryClientId" : z.inventoryClientId})
                  if(!_.isEmpty(new_clients)){     
                    clientsObj.push(new_clients)
                    clientsObj = _.uniqBy(clientsObj, 'inventoryClientId');
                  }
                   processObj.push(...z.userProcesses)
                   processObj = _.uniqBy(processObj, 'inventoryProcessId');
               })
            })
          }) 
        }
        // }       
        _.map(edit.reports, (y1) =>{
        reportli.push(_.find(reportlist, {"reportName" : y1.reportName}))      
      })           
        
        let roles = _.find(rolesData, {'rolesName':edit.rolesName})
        let supervisor = _.find(supervisorData, {'supervisorUsersName':edit.supervisorUsersName}) 
        this.setState({ selectedregionName:regionObj, selectedcenterName:centerObj , selectedclientName:clientsObj,
          selectedprocessName:processObj, selectedReports:reportli, selectedrole:roles,
          selectedSupervisor:supervisor})
     }
     
     
     if(_.isEmpty(leaveInfo)){
      leaveInfo.push({status:'NEW', toDate:'', fromDate:'', noOfDay:'' , reason:'' , comment:''})
      this.setState({leaveInfo})
  }  
    }	  
    handleSubmit =() => {  
       const{firstName, selectedSupervisor, email, password, mobileNumber, selectedregionName, lastName, userrecordStatus,
        selectedcenterName, selectedclientName, selectedprocessName, selectedrole, leaveInfo, selectedReports} = this.state;
       let leaveObjCloned;
        if(!_.isEmpty(leaveInfo)){
          leaveObjCloned = _.cloneDeep(leaveInfo)
        _.map(leaveObjCloned, (x) =>{
          if(x.status === 'NEW'){
            x.status ='ACTIVE'
          }
        })
        }
        let cloneDeepRegion = _.cloneDeep(selectedregionName);  
        let returnObj = [];
        _.map(cloneDeepRegion, (x) => {
          let centers =[]
          _.map(x.centers, (y) =>{
            let obj = _.find(selectedcenterName, {'inventoryCenterId':y.inventoryCenterId})
            if(typeof obj !== 'undefined'){
              centers.push({'inventoryCenterId':obj.inventoryCenterId, 'inventoryCenterName':obj.inventoryCenterName, userClients:[]})
            }    
            _.map(y.clients, (z) =>{
              let obj1 = _.find(selectedclientName, {'inventoryClientId':z.inventoryClientId})
              if(typeof obj1 !== 'undefined'){
                let newclients = _.find(centers, {'inventoryCenterId':y.inventoryCenterId})
                if(typeof  newclients !== 'undefined' && _.isArray(newclients.userClients)){
                  newclients.userClients.push({'inventoryClientId':obj1.inventoryClientId, 'inventoryClientName':obj1.inventoryClientName, userProcesses:[]})
                }
              }
              _.map(z.processes, (z1) =>{
                  let obj2 = _.find(selectedprocessName, {'inventoryProcessId':z1.inventoryProcessId})
                  if(typeof obj2 !== 'undefined'){
                    let abc = _.find(centers, {'inventoryCenterId':y.inventoryCenterId})
                    if(typeof abc !== 'undefined' && typeof abc.userClients !== 'undefined'){
                        let abc1 = _.find(abc.userClients, {'inventoryClientId':z.inventoryClientId})
                        if(typeof abc1 !== 'undefined' && _.isArray(abc1.userProcesses)){
                          abc1.userProcesses.push(obj2)
                        }
                    }
                  }
              }) 
            })
          })
          let returnvalues  = {'inventoryRegionId':x.inventoryRegionId, 'inventoryRegionName':x.inventoryRegionName,
          "userCenters":centers}
          if(!_.isNull(returnvalues)) {
            returnObj.push(returnvalues)
          }
        })  
        let encyPassword='';
        if(!_.isEmpty(password) ){
        const publickey = process.env.REACT_APP_PUBLIC_KEY;
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publickey);
        encyPassword = encrypt.encrypt(password);     
      }
        if(this.props.editOption === true) {
          let updateUser = _.cloneDeep(this.props.edit)
          updateUser.email = email
          updateUser.status = userrecordStatus
          updateUser.firstName = firstName
          updateUser.lastName = lastName
          updateUser.clients = selectedclientName
          updateUser.userInventoryMaps = returnObj
          updateUser.userLeaveDetails = leaveObjCloned
          updateUser.mobileNumber = mobileNumber
          updateUser.roleId = selectedrole  ? selectedrole.roleId : null
          updateUser.rolesName = selectedrole ? selectedrole.rolesName : null
          updateUser.reports = selectedReports
          updateUser.supervisorUsersId = selectedSupervisor ? selectedSupervisor.supervisorUsersId : null
          updateUser.supervisorUsersName = selectedSupervisor ? selectedSupervisor.supervisorUsersName : null
          updateUser.password = encyPassword  
          updateUser['userName'] = this.props.loginAction.userName    
          this.props.action.editUser(updateUser)
        } 
        this.props.closeModal()
    }
    validateForm() {     
      if(this.state.employeeId && this.state.employeeId.length > 0 && this.state.firstName && this.state.firstName.length > 0 &&
          this.state.emailIsValid && this.state.lastName && this.state.lastName.length > 0 && this.state.email && this.state.email.length > 0 && !_.isEmpty(this.state.selectedrole)
          && !_.isEmpty(this.state.selectedregionName) && !_.isEmpty(this.state.selectedcenterName) && !_.isEmpty(this.state.selectedclientName) && !_.isEmpty(this.state.selectedprocessName) 
        ){
          if(this.state.changePassword===true){
          if(this.state.password && this.state.password.length>5){
            if(this.state.selectedrole && this.state.selectedrole.rolesName === 'Agent'){
              let Category = false
              _.map(this.state.selectedprocessName, (obj) => {
                if(_.has(obj,'inventoryCategoryId') && !_.isNull(obj.inventoryCategoryId)){
                  Category = true
                } else {
                  Category = false
                }
              })
              
              if(!_.isEmpty(this.state.selectedSupervisor) && Category === true){
                return true
              }
            } else {
              return true
           }
          }
          }else{
            if(this.state.selectedrole && this.state.selectedrole.rolesName === 'Agent'){
              let Category = false
              _.map(this.state.selectedprocessName, (obj) => {
                if(_.has(obj,'inventoryCategoryId') && !_.isNull(obj.inventoryCategoryId)){
                  Category = true
                } else {
                  Category = false
                }
              })
              
              if(!_.isEmpty(this.state.selectedSupervisor) && Category === true){
                return true
              }
            } else {
              return true
           }
          }     
      }      
    }
		addroles = () =>{
			const{inventory} = this.props;			
			let regionUI = _.map(inventory.roles, (obj)=>{
				return(<option id='roles' value={obj.label}>{obj.label}</option>)
			})
			return regionUI;
    }
    addagentCategory = () => {
      const{inventory} = this.props;			
			let regionUI = _.map(inventory.agentCatgories, (obj)=>{
				return(<option id='agentCategory' value={obj.label}>{obj.label}</option>)
			})
			return regionUI;

    }
		addregions = () =>{
      const{inventory} = this.props;
      if(!_.isEmpty(inventory)){
      let regionNames = inventory 
      return regionNames;
      }
		}
		addcenters = () => {
      const{selectedregionName} = this.state;
      const{inventory} = this.props;
      let centerName=[];
      if(!_.isEmpty(inventory) && !_.isEmpty(selectedregionName)){
        _.map(selectedregionName, (obj)=>{
          let x = _.filter(obj.centers);
          centerName.push(...x );
          centerName = _.uniqBy(centerName, 'inventoryCenterId');          
       })
       return centerName;
        
      }
		}
		addclients= () => {
      const{selectedcenterName} = this.state;
      const{inventory} = this.props;
      let clientName=[];
      if(!_.isEmpty(inventory) && !_.isEmpty(selectedcenterName)){
       _.map(selectedcenterName, (obj)=>{
         clientName.push(...obj.clients);
         this.bulkclientName=clientName     
       }) 
      return _.uniqBy(clientName, 'inventoryClientId');
      }
    }
    processNames = () => {
      const{selectedclientName} = this.state;
      const{inventory} = this.props;
      let processName=[];
      if(!_.isEmpty(inventory)){
      _.map(selectedclientName, (obj)=>{
          let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processName.push(...z.processes)
            processName = _.uniqBy(processName, 'inventoryProcessId');
          })
          
      }) 
       return processName;
      }
    }		
    handleChange = event => {
      this.setState({
      [event.target.id]: event.target.value
      });
    }
    handleSelect = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedregionName: e} );
      if(!_.isEqual(this.state.selectedregionName, e)){    
        this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
      }
    }
    handleSelectCenter = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedcenterName: e});
      if(!_.isEqual(this.state.selectedcenterName, e)){               
        this.setState({selectedclientName:[], selectedprocessName:[]})
      }
    }
    handleSelectClient = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedclientName: e});
      if(!_.isEqual(this.state.selectedclientName, e)){
        this.setState({selectedprocessName:[]})
      }
    }
    handleSelectProcess = (e) => {
      if(!_.isArray(e)){
        e = [e]
      }
      this.setState({selectedprocessName: e});
    }
    handleSelectRoles = (e) => {
      this.setState({selectedrole: e});
      if(!_.isEqual(this.state.selectedrole, e)){    
        this.setState({selectedregionName:[], selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
      }
    }
  
    handleSelectReports = (e) => {
      this.setState({selectedReports: e});
    }
    handleSelectSupervisor = (e) => {
      this.setState({selectedSupervisor: e});
    }
    chooseModal =() =>{
      this.setState({showModal:true})
    }
    chooseModalClose =() =>{
      this.setState({showModal:false})
    }
    
    handleProcessCategories = (obj) =>{
      this.setState({selectedprocessName:[obj]})
    }
    handleChangeStart = (i, date) => {
       const formattedDate = date.getDate()+'/'+[date.getMonth()+1]+'/'+date.getFullYear();
       this.setState({["startDate"+i]: date});
       const {leaveInfo} = this.state;
       let indexed = leaveInfo[i];
       indexed['toDate'] = formattedDate;
       this.setState({leaveInfo})
    }
    handleChangeEnd = (i, e) => {     
      const formattedDate = e.getDate()+'/'+[e.getMonth()+1]+'/'+e.getFullYear();
      this.setState({["endDate"+i]: e});   
      const {leaveInfo} = this.state;
      let indexed = leaveInfo[i];
      indexed['fromDate'] = formattedDate;
      let x = this.calculateDaysLeft(this.state['startDate'+i], e)
      indexed['noOfDays'] = x+1;
      this.setState({leaveInfo})

    }
    calculateDaysLeft(startDate, endDate) {
      if (!moment.isMoment(startDate)) startDate = moment(startDate);
      if (!moment.isMoment(endDate)) endDate = moment(endDate);  
      return endDate.diff(startDate, "days");
    }
    handleReason = (i, prop, e) =>{
      const {leaveInfo} = this.state;
      let indexed = leaveInfo[i];
      indexed[prop] = e.target.value;      
      this.setState({leaveInfo})
    }
    handleCancelled = (i) =>{
      const {leaveInfo} = this.state;
      let indexed = leaveInfo[i];
      indexed['status'] = 'CANCEL';      
      this.setState({leaveInfo})
    }

    leaveTable = () =>{
     return  _.map(this.state.leaveInfo, (obj, i) =>{      
        return(
          <tr>           
            <td>{(obj.status === 'NEW') ? <DatePicker
            selected={this.state["startDate"+i]}
            className='myDatePicker'
            selectsStart           
            showMonthDropdown   
            startDate={this.state["startDate"+i]}
            endDate={this.state["endDate"+i]}
            onChange={(e)=>this.handleChangeStart(i, e)}
            minDate={new Date()} 
          />            
            :obj.toDate}</td>
            <td>{(obj.status === 'NEW') ?  
            <DatePicker
            selected={this.state["endDate"+i]}
            selectsEnd
            startDate={this.state["startDate"+i]}
            endDate={this.state["endDate"+i]}
            onChange={(e)=>this.handleChangeEnd(i, e)}
            minDate={new Date()}
            /> : obj.fromDate}</td>
            <td>{(obj.status === 'NEW') ? <textarea style={{'width':'100%'}} onChange={(e)=>this.handleReason(i, 'reasons', e)}/> : obj.reasons}</td>
            <td>{(obj.status === 'NEW') ?  <textarea style={{'width':'100%'}}  onChange={(e)=>this.handleReason(i, 'comments', e)}/> :obj.comments}</td>
            <td>{obj.noOfDays}</td>            
            <td>{obj.status}</td>
            <td>{(obj.status === 'ACTIVE' || obj.status === 'NEW') ? 
            <i class="fas fa-calendar-times accord " onClick={()=>this.handleCancelled(i)}></i> : null}</td>
          </tr>
        )
      })
    }
    addLeaveRow = () =>{
      const {leaveInfo} = this.state;
      let obj = _.cloneDeep(leaveInfo[0]);
      obj.status ='NEW'
      obj.toDate =''
      obj.fromDate =''
      obj.noOfDays=''
      obj.reasons=''
      obj.comments=''
      leaveInfo.push(obj)
      this.setState({leaveInfo})
    }
    deleteLeaveRow = () =>{
      const {leaveInfo} = this.state;
      let index = _.findLastIndex(leaveInfo, {'status':'NEW'})
      if(typeof index !== 'undefined' && index !== 0){
         _.pullAt(leaveInfo, index)
         this.setState({leaveInfo})
      }
    } 
    // handleLeave = (e) =>{
    //   this.setState({isLeave:e.target.checked})
    //   if(e.target.checked === true){
    //     const {leaveInfo} = this.state;
            
       
    //   }
    // }
    onhandleStatusChange=(e) =>{
      this.setState({userstatus:e.target.checked})
      if(e.target.checked === true){
        this.setState({userrecordStatus:'ACTIVE'})
      } else {
        this.setState({userrecordStatus:'INACTIVE'})
      }
    }
    isValidEmailAddress = (address) =>{
      if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)){
        return true
      } else {
        return false
      }
    }
    onhandlePasswordChange = (e) => {
      this.setState({changePassword:e.target.checked})
    }
    viewPassword = (prop) => {
      this.setState({passwordtype:prop}) 
     }
    render(){ 
      const {loginAction} = this.props
        return(         
            <Modal
            show={true}
            onHide={this.props.closeModal}
            dialogClassName="modal-120w"
						//aria-labelledby="example-custom-modal-styling-title"
						size="xl"
						aria-labelledby="contained-modal-title-vcenter"
						centered
            >
            <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
             EDIT USER
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
						<form>
            <span className="RedColoring">* indicates required field</span>
            <span className='alignRight'>            
            {this.props.edit.status === "NEW" ?   <span className='alignRight'>Status : NEW</span> :
            <span>
            <input type="checkBox" style={{verticalAlign:"middle"}}
            checked={this.state.userstatus} onChange={this.onhandleStatusChange}/>:Active</span> }
            </span>
            <div className="clearBoth">
            <Row>
              <Col>
            <span>
            <input type="checkBox" style={{verticalAlign:"middle"}}
            checked={this.state.changePassword} onChange={this.onhandlePasswordChange}/>&nbsp;Change Password</span>
            {this.state.changePassword === true ? 
            <FormGroup controlId="password" >
            <InputGroup><InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1"><i class="fas fa-lock"></i></InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
                autoFocus
                type={this.state.passwordtype}
                value={this.state.password}
                onChange={this.handleChange}
                placeholder="Minimum 6 characters"
                
            />
              <InputGroup.Append>
              <InputGroup.Text id="basic-addon2">{this.state.passwordtype === "password" ?     
                <i class='fas fa-eye' onClick={()=>this.viewPassword('text')} /> :
                <i class='fas fa-eye-slash' onClick={()=>this.viewPassword('password')} /> }</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
        </FormGroup>             
          
            : null}
            </Col>
            <Col>
            </Col>
            <Col></Col>
            </Row>
            
            <Row>           
						<Col>
            <FormGroup controlId="employeeId" >
                <FormLabel>User ID<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user"/></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="employeeId"
                    value={this.state.employeeId}
                    onChange={this.handleChange}
                    disabled={true}
                    maxLength="30" 
                /></InputGroup>
            </FormGroup>
            <FormGroup controlId="firstName" >
                <FormLabel>First Name<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="firstName"
                    value={this.state.firstName}
                    onChange={this.handleChange}
                    maxLength="50" 
                /></InputGroup>
            </FormGroup>
            </Col>
            <Col>
            <FormGroup controlId="email" >
                <FormLabel>Email<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-envelope"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="email"
                    value={this.state.email}
                    onBlur={() => this.setState({
                      emailIsValid: this.isValidEmailAddress(this.state.email)
                    }) }
                    maxLength="100" 
                    onChange={this.handleChange}
                /></InputGroup>
                 {(this.state.emailIsValid === false) ? <span className="RedColoring">&nbsp;****Enter valid email****</span>: null}
            </FormGroup>
            <FormGroup controlId="lastName" >
                <FormLabel>Last Name<span className="RedColoring"> *</span></FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="lastName"
                    value={this.state.lastName}
                    onChange={this.handleChange}
                    maxLength="50"
                /></InputGroup>
            </FormGroup>
           </Col>
						<Col> 
            <FormGroup controlId="mobileNumber" >
                <FormLabel>Mobile Number</FormLabel>
                <InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-mobile-alt"></i></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    autoFocus
                    type="mobileNumber"
                    value={this.state.mobileNumber}
                    onChange={this.handleChange}
                /></InputGroup>
            </FormGroup>	
            <FormGroup>
            <FormLabel>Supervisor{this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ?
              <span className="RedColoring"> *</span> : null : null}</FormLabel>             
            <Picky keepOpen={false}
            value={this.state.selectedSupervisor}
            options={this.props.supervisorData}
            onChange={this.handleSelectSupervisor}
            open={false}
            valueKey="supervisorUsersName"
            labelKey="supervisorUsersName"
            multiple={false}
            includeFilter={true}
            clearFilterOnClose={true}
            includeSelectAll={false}
            placeholder='Select Supervisor'
            dropdownHeight={600}
          />
          {!_.isEmpty(this.state.selectedSupervisor) ? <h6>{this.state.selectedSupervisor.supervisorUsersId}</h6> : null}         
          </FormGroup>
            </Col>
            </Row>
            <Row>
            <Col>
          	<FormGroup>
            <FormLabel>Role<span className="RedColoring"> *</span></FormLabel> 
                <Picky keepOpen={false}
                value={this.state.selectedrole}
                options={this.props.rolesData}
                onChange={this.handleSelectRoles}
                open={false}
                valueKey="rolesName"
                labelKey="rolesName"
                includeFilter={true}
                clearFilterOnClose={true}
                multiple={false}
                includeSelectAll={true}
                placeholder='Select Roles'
                dropdownHeight={600}
              />
          </FormGroup>
            <FormGroup >
              <FormLabel>Client<span className="RedColoring"> *</span></FormLabel> 
              <Picky keepOpen={false}
                value={this.state.selectedclientName}
                options={this.addclients()}
                onChange={this.handleSelectClient}
                open={false}
                valueKey="inventoryClientName"
                labelKey="inventoryClientName"
                multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
                includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
                clearFilterOnClose={true}
                placeholder='Select Client'
                dropdownHeight={600}
              />
            </FormGroup>
            </Col>
            <Col>
            <FormGroup >
              <FormLabel>Region<span className="RedColoring"> *</span> </FormLabel> 
              <Picky keepOpen={false}
              value={this.state.selectedregionName}
              options={this.addregions()}
              onChange={this.handleSelect}
              open={false}
              valueKey="inventoryRegionName"
              labelKey="inventoryRegionName"
              includeFilter={true}
              clearFilterOnClose={true}
              multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              placeholder='Select Region'
              dropdownHeight={600}
              />            
          </FormGroup>
            <FormGroup >
              <FormLabel>Process<span className="RedColoring"> *</span></FormLabel> 
          {(!_.isEmpty(this.state.selectedrole) &&  this.state.selectedrole.rolesName === 'Agent') ?
          <div>
            <center>
            <p onClick={()=>this.chooseModal()}  className="cursorPointer"> 
            {!_.isEmpty(this.state.selectedprocessName) ?  'Click To View Process and Agent Category' :  
            'Click To Select Process and Agent Category'}
            </p></center>
            {this.state.showModal ?
              <ProcessWise 
                callBack={(a)=>this.handleProcessCategories(a)}
                categories = {this.props.categoryData}
                selectedprocessName={_.cloneDeep(this.state.selectedprocessName)}
                process={this.processNames()}
                handleClose={this.chooseModalClose}/>
              : null }
              </div>
              : 
              <Picky keepOpen={false}
                value={this.state.selectedprocessName}
                options={this.processNames()}
                onChange={this.handleSelectProcess}
                open={false}
                valueKey="inventoryProcessName"
                labelKey="inventoryProcessName"
                multiple={true}
                includeFilter={true}
                clearFilterOnClose={true}
                includeSelectAll={true}
                placeholder='Select Process Name'
                dropdownHeight={600}
            /> }
            </FormGroup> 
            
            </Col>
            <Col>                 
           <FormGroup>
              <FormLabel>Center<span className="RedColoring"> *</span></FormLabel> 
              <Picky keepOpen={false}
              value={this.state.selectedcenterName}
              options={this.addcenters()}
              onChange={this.handleSelectCenter}
              open={false}
              valueKey="inventoryCenterName"
              labelKey="inventoryCenterName"
              multiple={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              includeSelectAll={this.state.selectedrole ? this.state.selectedrole.rolesName === 'Agent' ? false : true : true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Center'
              dropdownHeight={600}
            />
          </FormGroup>
          <FormGroup >
            <FormLabel> Reports</FormLabel> 
						<Picky keepOpen={false}
              value={this.state.selectedReports}
              options={this.props.reportlist}
              onChange={this.handleSelectReports}
              open={false}
              valueKey="reportName"
              labelKey="reportName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={true}
              clearFilterOnClose={true}
              placeholder='Select Reports'
              dropdownHeight={600}
            />
          </FormGroup> 
            </Col>
            </Row>
            { (loginAction.roles === '[Supervisor - Agent/Team Lead]' || loginAction.roles ==='[System Admin]' ) ?
            <Row>             
              <Col><b>Leave Records</b>              
              <Table responsive>
                <thead><th>To</th><th>From</th><th>Reason</th>
                <th>Comments</th><th>No of Days</th><th>Status</th><th><i class="fas fa-plus-circle accord" onClick={this.addLeaveRow}/>          
                <i class="fas fa-minus-circle accord" onClick={this.deleteLeaveRow}/>
                </th></thead>
                <tbody>
                  {this.leaveTable()}                  
                </tbody>
              </Table> 
              </Col>             
            </Row> : null}
            <Row>
              <Col>              
						<Button
            block
            className=''          
            type="button"
            disabled={!this.validateForm()}
            onClick={this.handleSubmit}           
            > <b>Update</b>
            </Button></Col>        
            </Row>
            </div>
						</form>
            </Modal.Body>
            </Modal>
        
        );
    }
}
